/* eslint-disable import/no-unused-modules */
import { inject } from './AsyncScriptLoader';
import queue from './queue';

let initiated = false;
const LCP_TIME = 6000;

// TODO: we can use segment snippet for server Segment loading
const scriptSrc = ` !function(){var analytics=window.analytics=window.analytics||[];
  if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");
  else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];
  analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";
  t.async=!0;t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics._writeKey="YOUR_WRITE_KEY";analytics.SNIPPET_VERSION="4.13.2";
  analytics.load('ABCD');
  analytics.page();
  analytics.ready(segmentFlushQueue);
  }}();`;

export async function init() {
  retry();
  return inject('', scriptSrc);
}

const wait = delay => new Promise(resolve => setTimeout(() => resolve(true), delay));

export const retry = async (attempts = 0, delay = 1500) => {
  await wait(delay);
  if (isLoaded()) return true;
  if (attempts >= 2) return true;
  inject('', scriptSrc);
  // eslint-disable-next-line no-param-reassign
  attempts += 1;
  return retry(attempts, delay);
};

export const isLoaded = () => !!window.analytics;

export const flushQueue = () => {
  const tracksStorage = queue.getAll() ?? [];
  tracksStorage.forEach(item => {
    fireEvent(item);
    queue.remove();
  });
};

export const fireEvent = ({ eventName = '', props = {}, contextData = {}, cb }) => {
  window.analytics.track(eventName, props, contextData, cb);
};

export const segmentTrackEvent = ({ eventName, props, contextData, cb }) => {
  if (isLoaded()) {
    flushQueue();
    fireEvent({
      eventName,
      props,
      cb,
      contextData,
    });
  } else {
    queue.push({ eventName, props, contextData, cb });
  }
};

export const initSegment = () => {
  window.segmentFlushQueue = flushQueue;
  if (initiated) return true;
  init();
  initiated = true;
  window.addEventListener('unload', () => {
    flushQueue();
  });
  return initiated;
};

export const track = event => {
  if (!initiated) {
    initSegment();
  }
  segmentTrackEvent(event);
};

export const timedOutInit = () => {
  if (initiated) return true;
  setTimeout(() => init(), LCP_TIME);
  return true;
};
